export default __webpack_public_path__ + "static/media/esylogo1.474a0bdf.png";